import {Component, Inject, OnInit} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ConsuntivoVolumiModel} from '../../../models/ConsuntivoVolumiModel';
import {ConsuntivoVolumiService} from '../../monthly-actual/consuntivo-volumi/service-consuntivo-volumi/consuntivo-volumi.service';
import {ConsuntivoChargesModel} from '../../../models/ConsuntivoChargesModel';
import {ConsuntivoChargesService} from '../../monthly-charges/consuntivo-charges/service-consuntivo-charges/consuntivo-charges.service';

@Component({
  selector: 'app-update-all-workflow-status-dialog',
  templateUrl: './update-all-workflow-status-dialog.component.html',
  styleUrls: ['./update-all-workflow-status-dialog.component.scss']
})
export class UpdateAllWorkflowStatusDialogComponent implements OnInit {

  volumeList?: ConsuntivoVolumiModel[];
  chargesList?: ConsuntivoChargesModel[];

  workflowStatusList: string[];
  note: string;
  selectedStatus: string;

  constructor(public dialogData: MatDialogRef<UpdateAllWorkflowStatusDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private consuntivoVolumiService: ConsuntivoVolumiService,
              private consuntivoChargesService: ConsuntivoChargesService) {
    this.volumeList = data.volumeList;
    this.chargesList = data.chargesList;
  }

  ngOnInit() {
    this.workflowStatusList = new ProjectConstants().WORKFLOW_STATUS_LIST;
  }

  onChangeWorkflowStatus($event, status) {
    if ($event && $event.isUserInput && status) {
      this.selectedStatus = status;
      console.log($event, status);
      // if (!this.isEditing) {
      //   this.isEditing = true;
      //   this.editingRows = [];
      // }
      // element.workflowStatus = status;
      // this.editingRows.push(element);
    }
  }

  close() {
    this.dialogData.close();
  }

  save() {
    // if (this.note && this.note !== '') {
      const workflowNote = this.note ? this.note : '';
      if (this.volumeList) {
        this.volumeList.filter(v => v.workflowStatus !== 'Closed').forEach(v => {
          if (v.notes && v.notes !== '') {
            v.notes += ' ' + workflowNote;
          } else {
            v.notes = workflowNote;
          }
          v.workflowStatus = this.selectedStatus;
        });
        this.consuntivoVolumiService.updateWorkflowStatusMassive(this.volumeList).subscribe(
          res => {
            this.close();
          }, error => {
          }
        );
      } else if (this.chargesList) {
        this.chargesList.filter(c => c.workflowStatus !== 'Closed').forEach(v => {
          if (v.notes && v.notes !== '') {
            v.notes += ' ' + workflowNote;
          } else {
            v.notes = workflowNote;
          }
          v.workflowStatus = this.selectedStatus;
        });
        this.consuntivoChargesService.updateWorkflowStatusMassive(this.chargesList).subscribe(
          res => {
            this.close();
          }, error => {
          }
        );
      }
    // }
  }
}
